import { render, staticRenderFns } from "./ClientRecord.vue?vue&type=template&id=61a6ac9c&scoped=true"
import script from "./ClientRecord.vue?vue&type=script&lang=js"
export * from "./ClientRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6ac9c",
  null
  
)

export default component.exports